/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 *
 */
angular.module('bulbApp.contentEditorModule')

.directive('uploadingImageBlock', uploadingImageBlock);

function uploadingImageBlock() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/contenteditor/uploadingimageblock.html',
    link: function($scope, element, attrs) {

      /*
       * If this is one of our supported image file types and a file type supported by the browser, then we can go ahead
       * and return true else false. This is then used by the uploadingimageblock to make sure that a broken image icon
       * is not displayed when attempting up use our additional image file types.
       */
      $scope.isBrowserSupportedImage = function() {

        // After this runs once, we store it in the isSupportedImage variable and just return that. This prevents
        // a regex.match from running multiple times but also prevents a $digest cycle overflow on the client
        if (this.isSupportedImage) {
          return this.isSupportedImage;
        }

        var supportedImageExtensionRegex = /\.(gif|jpe?g|jfif|bmp|png)$/i;
        var filename = $scope.contentBlockCtrl.contentBlock.data.originalFiles[0].name;

        this.isSupportedImage = filename.match(supportedImageExtensionRegex);
        return this.isSupportedImage;
      };
    }
  };
}
